import { Checkbox } from "primereact/checkbox";
import * as React from "react";
import { useTranslation } from "react-i18next";
import "./PrwAcceptTermsOfServices.scss";

const PrwAcceptTermsOfServices = (props: any) => {
  const { t } = useTranslation();

  return (
    <div className="mb-0 p-field-checkbox prw-accept-terms-of-service">
      <Checkbox id={props.id}
        onChange={(e) => props.onChange(e.checked)}
        checked={props.value}
      ></Checkbox>
      <label htmlFor={props.id} className="text-sm p-checkbox-label">{t("signUp.label.iAccept") + " " + t("signUp.label.termsOfServices")}</label>
    </div>
  );
};

export default PrwAcceptTermsOfServices;
